import { render, staticRenderFns } from "./footer.component.vue?vue&type=template&id=4f3ffb58&scoped=true&"
import script from "./footer.component.js?vue&type=script&lang=js&"
export * from "./footer.component.js?vue&type=script&lang=js&"
import style0 from "./footer.component.scss?vue&type=style&index=0&id=4f3ffb58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3ffb58",
  null
  
)

export default component.exports